import * as React from "react";
import { LegalPage } from "./LegalPage";
import "../assets/LegalPage.scss";
import { regionHelper } from "src/features/region";

interface Props {
    goBack?: () => void;
    closeIcon?: boolean;
}

const getPrivacyUrl = (): string => {
    if (regionHelper.isAU) return "legal/privacy-policy---australia";
    if (regionHelper.isUK) return "legal/privacy-policy-uk";
    return `legal/app-meandu-privacy-policy-${regionHelper.region.id}`;
};

export const PrivacyPolicy = ({ goBack, closeIcon }: Props) => {
    return <LegalPage title="Privacy Policy" closeIcon={closeIcon} goBack={goBack} relativeUrl={getPrivacyUrl()} />;
};
